/*
 * @Author: wangshengqiang
 * @Date: 2022-01-03 14:07:00
 * @LastEditTime: 2022-01-03 14:47:28
 * @LastEditors: wangshengqiang
 * @Description: 自定义证件附件确认组件
 */
import React from 'react';
import './index.less';

const CertAttachmentConfirm = ({
  itemlabel,
  itemValue = []
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "item certAttachmentConfirm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "left"
  }, itemlabel), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, itemValue.map(i => {
    return /*#__PURE__*/React.createElement("div", {
      className: "img-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: i,
      alt: "11"
    }));
  })));
};

export default CertAttachmentConfirm;